import { GOOGLE_USER_INFO } from "@configs";
import {
    IChangePassword,
    IEmailForm,
    IFBSignup,
    IGGSignup,
    ILineLogin,
    ILineSignup,
    ILogin,
    IPagination,
    IPhone,
    IResetPassword,
    ISocialMedia,
    IUpdateAnswer,
    IUserSetting,
} from "@interfaces";
import { IFBLogin, IGGLogin, ILinePhone, ISaveQuestion } from "./../Interfaces/auth";
import axiosClient from "./axiosClient";

export const authApi = {
    login: (params: ILogin) => {
        const url = "/auth/client-login";
        return axiosClient.post(url, params);
    },
    getInfo: () => {
        const url = "/users/profile/user";
        return axiosClient.get(url).catch((error) => {
            localStorage.clear();
            sessionStorage.clear();
            window.location.reload();
            return Promise.reject(error);
        });
    },
    updateProfile: (values: IUserSetting) => {
        const url = "users/profile";
        return axiosClient.put(url, values);
    },
    refreshToken: (refreshToken: string) => {
        const url = "/auth/login-refresh-token";
        const params = {
            refreshToken,
        };
        return axiosClient.post(url, params);
    },
    verifyToken: (token: string) => {
        const url = "/auth/internal/validate-token";
        return axiosClient.post(
            url,
            {},
            {
                headers: {
                    "access-token": token,
                },
            }
        );
    },
    lineLogin(params: ILineLogin) {
        const url = "/auth/client-line-login";
        return axiosClient.post(url, params);
    },
    lineSignup(params: ILineSignup) {
        const url = "/auth/client-line-signup";
        return axiosClient.post(url, params);
    },
    fbLogin(params: IFBLogin) {
        const url = "/auth/client-facebook-login";
        return axiosClient.post(url, params);
    },
    fbSignup(params: IFBSignup) {
        const url = "/auth/client-facebook-signup";
        return axiosClient.post(url, params);
    },
    //google
    ggLogin(params: IGGLogin) {
        const url = "/auth/client-google-login";
        return axiosClient.post(url, params);
    },
    ggSignup(params: IGGSignup) {
        const url = "/auth/client-google-signup";
        return axiosClient.post(url, params);
    },
    getUserInfoByGg(params: IPagination) {
        const url = GOOGLE_USER_INFO;
        return axiosClient.get(url, {
            params,
        });
    },
    changePassword(values: IChangePassword) {
        const url = "users/merchant/password";
        return axiosClient.put(url, values);
    },
    registerEmail: (email: string) => {
        const url = "/auth/client-register";
        const params = {
            email,
        };
        return axiosClient.post(url, params);
    },
    sendResetPassword: (email: string) => {
        const url = "/auth/send-reset-password";
        const params = {
            email,
        };
        return axiosClient.post(url, params);
    },
    resetPassword: (values: IResetPassword) => {
        const url = "/auth/reset-password";
        return axiosClient.put(url, values);
    },
    registerPhone: (value: IPhone) => {
        const url = "/auth/twilio-signup";
        return axiosClient.post(url, value);
    },
    loginPhone: (value: IPhone) => {
        const url = "/auth/twilio-login";
        return axiosClient.post(url, value);
    },
    verifyPhone: (value: IPhone) => {
        const url = "/auth/twilio-verify";
        return axiosClient.post(url, value);
    },
    resendPhone: (value: IPhone) => {
        const url = "/auth/resend-phone";
        return axiosClient.post(url, value);
    },
    createPassword: (values: IEmailForm | ISocialMedia) => {
        const url = "/auth/sign-up/form";
        return axiosClient.put(url, values);
    },
    createMemberPreType: (values: any) => {
        const url = "/auth/sign-up/member-type-form";
        return axiosClient.put(url, values);
    },
    updateAnswer: (values: IUpdateAnswer) => {
        const url = "/users/update-answer";
        return axiosClient.put(url, values);
    },
    updateLine: (values: ILineLogin) => {
        const url = "users/link-line";
        return axiosClient.put(url, values);
    },
    getQuestionIsRequire: () => {
        const url = "/auth/getQuestionIsRequire";
        return axiosClient.get(url);
    },
    getQuestionSignUp: () => {
        const url = "/auth/getQuestionSignUpIsRequire";
        return axiosClient.get(url);
    },
    saveQuestionSignUp: (params: any) => {
        const url = "/auth/saveQuestionSignUpIsRequire";
        return axiosClient.put(url, params);
    },
    saveQuestionIsRequire: (params: ISaveQuestion[]) => {
        const url = "/auth/saveQuestionIsRequire";
        return axiosClient.put(url, params);
    },
    // line + tel
    clientLinePhoneLogin: (value: ILinePhone) => {
        const url = "/auth/clientLinePhoneLogin";
        return axiosClient.post(url, value);
    },
    clientLinePhoneOtpVerify: (value: IPhone) => {
        const url = "/auth/clientLinePhoneOtpVerify";
        return axiosClient.post(url, value);
    },
    clientResendLinePhone: (value: IPhone) => {
        const url = "/auth/clientResendLinePhone";
        return axiosClient.post(url, value);
    },
    getMemberTypeConfig: () => {
        const url = "/merchants/MemberTypeList";
        return axiosClient.get(url);
    },
    getMemberTypeField: (value: { gId: string; tId: string }) => {
        const url = `/merchants/getMemberTypeField/${value?.gId}/${value.tId}`;
        return axiosClient.get(url);
    },
    getChannelList: () => {
        const url = "/channel";
        return axiosClient.get(url);
    },
    verifyEmail: (value: any) => {
        const url = "auth/send-email-code";
        return axiosClient.post(url, value);
    },
    verifyEmailCode: (value: any) => {
        const url = "auth/verify-email-code";
        return axiosClient.post(url, value);
    },
    getExpirePoint: () => {
        const url = "/points/expire";
        return axiosClient.get(url);
    },
    getValidateKey: (params: any) => {
        const url = "external-data-source/validate-key";
        return axiosClient.get(url, { params });
    },
    getValidateKeyValue: (params: any) => {
        const url = "external-data-source/pre-signup";
        return axiosClient.get(url, { params });
    },
    saveClientQuestions: (params: any) => {
        const url = "auth/saveClientQuestions";
        return axiosClient.put(url, params);
    },
    syncBalance: (prams: string) => {
        const url = "points/" + prams + "/sync-balance";
        return axiosClient.post(url);
    },
    generateCryptoToken: (params: any) => {
        const url = "auth/generate-crypto-token";
        return axiosClient.post(url, params);
    },
};
